<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="60vw">
    <v-card>
      <v-card-title>
        <span class="headline">案件予算削除申請</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-layout column mb-4>
            <v-flex class="label">期間</v-flex>
            <v-flex :class="['value', budget.isNew ? 'is-new' : '']">
              <AppPeriod
                :start="ioStartDatePartDate"
                :end="ioEndDatePartDate"
              />
            </v-flex>
          </v-layout>
          <v-layout column mb-4>
            <v-flex class="label">予算</v-flex>
            <v-flex :class="['value', budget.isNew ? 'is-new' : '']">
              <AppCurrency
                :value="budget.summary.budget"
                :currency="currency"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="$emit('input', false)">キャンセル</v-btn>
        <v-btn @click="requestDelete" color="primary">削除申請</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dayjs from 'dayjs'
import {
  actions as snackbarActions,
  snackbarType,
} from '@/vuex/modules/ui/snackbar/constants'

export default {
  name: 'DetailModal',
  props: {
    value: Boolean,
    advertiser: {
      type: Object,
      require: false,
      default: () => {},
    },
    insertionOrder: {
      type: Object,
      require: false,
      default: () => {},
    },
    budget: {
      type: Object,
      require: false,
      default: () => {},
    },
    canEdit: Boolean,
  },
  data() {
    return {
      confirmationMessage: '案件予算を削除申請します。',
    }
  },
  computed: {
    currency() {
      return this.advertiser.currency
    },
    ioStartDatePartDate() {
      return dayjs(this.budget.startTime).format('YYYY-MM-DD')
    },
    ioEndDatePartDate() {
      return dayjs(this.budget.endTime).format('YYYY-MM-DD')
    },
  },
  methods: {
    async requestDelete() {
      const result = await this.$confirm(this.confirmationMessage, {
        body: this.confirmationBody,
        cancelText: 'キャンセル',
        okText: '申請する',
      })
      if (!result) {
        this.$emit('cansel')
        return
      }

      this.$emit('requestDeleteBudget', this.budget)
      this.insertionOrder.fetchBudgetList()
      this.$store.dispatch(snackbarActions.SHOW_SNACKBAR, {
        type: snackbarType.SUCCESS,
        message: '削除申請しました',
      })
      this.$emit('success')
    },
  },
}
</script>

<style scoped lang="scss">
.label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}

.value {
  font-size: 16px;

  &.is-new {
    color: #999999;
  }
}
</style>
